export default __webpack_public_path__ + "static/media/bottom-background.e69a8153.svg";